import api from '@/shared/utils/apiConfig';
import type { ApiResponse, Organization } from '../types/settings.types';

export const organizationSettingsAPI = {
  getMy: async (): Promise<ApiResponse<Organization>> => {
    const response = await api.get('/organizations/my');
    return response.data;
  },

  update: async (id: string, data: Partial<Organization>): Promise<ApiResponse<Organization>> => {
    const response = await api.put(`/organizations/${id}`, data);
    return response.data;
  },
};
